module.exports = __webpack_public_path__ + "img/edit_card.6bfce9e2.svg";